import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input, FormFeedback } from 'reactstrap';


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileurl: ""
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    SetData(data) {
        this.setState({
            fileurl: data.url
        });
    }
        
    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.firmas.delete}
                postUrl={api.proyectos.config.firmas.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Firma ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Firma"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                closeButton={true}
                danger={true}
                saveButtonLabel={"Eliminar"}
                buttonClass={"btn-danger"}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.SetData(data)}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Firma seleccionada</p>
                        <div className="ui-alert ui-alert-danger">
                            <i className="ti ti-trash" aria-hidden="true"></i>
                            <span>Esta acción eliminará la firma seleccionada.</span>
                        </div>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field">
                                <Label>Cargo</Label>
                                <Input type="text" name="cargo" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>

                    {this.state.fileurl &&
                        <section className="ui-section-block mt-3">
                            <p className="ui-section-label">Imagen</p>
                            <img className="ui-image-preview" src={api.BASE_URL + this.state.fileurl} alt=""></img>
                        </section>
                    }
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Firmas/Delete.js